import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useCloneToTargetCleanRooms = () => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  return useMutation(
    async (
      { crId, payload },
    ) => axiosInstance.post(cleanRoom(orgId).cloneToTargetCleanRooms(crId), payload),
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Successfully clone clean room template',
          type: 'success',
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response.data.message,
          type: 'error',
        }));
      },
    },
  );
};
